/**
 * All application resume forms storages will be defined here.
 *
 * @var const storages
 */
export const storages = {
    selected: null,
    storages: {
        //
    },
    generateSelected: null,
};